// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"f05b4ffe","967":"1ac06514"}[chunkId] + ".chunk.css";
};